import React from 'react';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();
  
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-purple-400 via-purple-500 to-red-500"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-12">
        <div className="text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            {t('homepage.hero.title')}
          </h1>
          
          <p className="text-lg md:text-xl lg:text-2xl text-white/90 font-medium max-w-4xl mx-auto leading-relaxed">
            {t('homepage.hero.subtitle')}
          </p>
        </div>
      </div>
    </section>
  );
}